import React, { useState, useEffect, useContext } from "react";
import { useFetchApi } from "../../hooks/useFetchApi";
import { StateContext } from "../../store/context";
import { TitleArea } from "../../components/Typography/titleArea";
import { StockSelectOptions } from "./components/stockSelectOptions";
import { DataTable } from "./components/dataTable";
import { usePreventCopy } from "../../hooks/usePreventCopy";
import DisclaimerButton from "../../components/DisclaimerButton";
import "../../styles/theme-tokens.css";
import "../../styles/glass-tokens.css";
import "./watchlist.theme.css";

const WatchlistScreen: React.FC = (): React.ReactElement => {
  usePreventCopy();
  const {
    authUser: { sub_plan, role_name },
  } = useContext(StateContext);

  const {
    response: updateResponse,
    loading: updateLoading,
    execute: updateWatchlist,
  } = useFetchApi("/api/watchlist", {}, "PUT", () => {
    getWatchlist();
  });

  const [stocks, setStocks] = useState<any>({});
  const [adverts, setAds] = useState<any>();
  const [watchlistData, setWatchlistData] = useState<any>();
  const [selectedStocks, setSelectedStockList] = useState<any[]>([]);

  const {
    response: watchlist,
    loading: watchlistLoading,
    execute: getWatchlist,
  } = useFetchApi("/api/watchlist", {}, "GET");

  const {
    response,
    loading: stockLoading,
    execute: getStocks,
  } = useFetchApi("/api/all-stocks", {}, "GET");

  const {
    response: ads,
    loading: adsLoading,
    execute: getAds,
  } = useFetchApi("/api/ads", {}, "GET");

  console.log("ads:", ads);

  useEffect(() => {
    getStocks();
    getAds();
    getWatchlist();
  }, []);

  useEffect(() => {
    if (response && Object.keys(response).length) {
      setStocks(response);
    }
  }, [response]);

  useEffect(() => {
    if (ads && !adsLoading) {
      setAds(ads);
    }
  }, [ads, adsLoading]);

  useEffect(() => {
    if (watchlist) {
      setWatchlistData(watchlist);
    }
  }, [watchlist, watchlistLoading]);

  const isPremiumUser =
    sub_plan === "Premium Plan" && role_name === "Premium Customer"
      ? true
      : false;

  const handleStarClickFromTable = async (
    stock: any,
    event: React.MouseEvent,
  ) => {
    event.stopPropagation();

    try {
      updateWatchlist({ stock_id: stock.stock_id, action: "remove" });
      const updatedStocks = selectedStocks.filter(
        (selectedStock) => selectedStock.id !== stock.stock_id,
      );
      setSelectedStockList(updatedStocks);
    } catch (error) {
      console.error("Failed to update watchlist:", error);
    }
  };

  return (
    <div className="vi-wl flex md:flex-row flex-col items-center md:items-start w-full select-none">
      <div className="flex flex-col w-full md:w-full h-full items-start px-4 py-3">
        <div className="w-full flex items-start justify-between gap-4">
          <TitleArea
            variant="page"
            title="Watchlist"
            subTitle="Your personalized list of stocks to watch. Stay updated on prices, trends, and key market moves."
          />
          <DisclaimerButton />
        </div>

        <hr className="hr-line w-full my-2" />

        <div className="w-full sm:w-[50%]">
          <StockSelectOptions
            selectedStocks={selectedStocks}
            setSelectedSotcks={setSelectedStockList}
            getWatchlist={getWatchlist}
            watchlistResData={watchlist}
          />
        </div>

        <div className={`w-full`}>
          <hr className="hr-line w-full my-2" />
          <section className="mt-6">
            <DataTable
              loading={watchlistLoading}
              data={watchlistData || []}
              onStarClick={handleStarClickFromTable}
              starLoading={updateLoading}
            />
          </section>
        </div>
      </div>
    </div>
  );
};

export default WatchlistScreen;
